import { Injector } from "./Injector";
import { h } from "tsx-dom";
import RedWarnUI from "../RedWarnUI";
import RedWarnStore from "app/data/RedWarnStore";

export default class PreferencesInjector implements Injector {
    async init(): Promise<void> {
        // check if on Project:(RedWarn|Ultraviolet)/Preferences
        if (
            RedWarnStore.currentPage.title.namespace === 4 &&
            /^(RedWarn|Ultraviolet)\/Preferences$/.test(
                RedWarnStore.currentPage.title.title
            ) &&
            mw.config.get("wgAction") === "view"
        ) {
            const preferences = new RedWarnUI.Preferences({
                excludeTabs: ["core"],
            });
            const preferencesElement = preferences.render();

            const target = document.querySelector("#mw-content-text");
            if (!target) {
                // Not a valid MediaWiki page.
                throw "Could not find mw-content-text";
            }
            target.innerHTML = "";
            target.removeAttribute("id");
            target.removeAttribute("class");
            target.appendChild(preferencesElement);
        }
    }
}
